<div
  class="invoice-shipping-rate-dialog__modal-wrapper"
  *ngIf="(data && data.salesOrderId) || (data && data.isBulkUpdate)"
>
  <div
    class="overlay"
    lumAppLoader
    [loading]="
      (loading$ | async) ||
      (loadingSettings$ | async) ||
      (submittingForm$ | async) ||
      false
    "
    [classes]="'loading blur'"
  ></div>

  <div
    *ngIf="invalidLocationAddress; else shippingLabelForm"
    class="lum-alert lum-alert--error mb-5"
  >
    Please update <b>"{{ warehouse.location_name }}"</b> from the warehouse and use
    valid address details.
    <p class="mt-2">
      <a href="/locations/warehouses" target="_blank"
        >>> Go to Warehouse Settings</a
      >
    </p>
  </div>

  <ng-template #shippingLabelForm>
    <form
      [formGroup]="form"
      class="shipping-quote__wrapper flex gap-4 grow"
      (submit)="onSubmit()"
    >
      <div class="flex align-center gap-3" *ngIf="!data.isBulkUpdate">
        <div class="shipping-quote__label">Ship Date</div>
        <div class="shipping-quote__input">
          <input
            formControlName="shipDate"
            type="date"
            required="true"
            class="lum-input"
          />
          <mat-error *ngIf="shipDateControl && shipDateControl.invalid">{{
            shipDateControl | validateField
          }}</mat-error>
        </div>
      </div>
      <div class="flex align-center gap-3" *ngIf="data.hasMultipleShipments">
        <div class="shipping-quote__label">Shipment</div>
        <div class="shipping-quote__input">
          <mat-select formControlName="salesOrderShipmentId" class="lum-select">
            <mat-option
              *ngFor="let shipment of data.salesOrderShipments; trackBy: trackById"
              [value]="shipment?.id"
              >{{ shipment.orderKey }}</mat-option
            >
          </mat-select>
          <mat-error
            *ngIf="
              salesOrderShipmentIdControl && salesOrderShipmentIdControl.invalid
            "
            >{{ salesOrderShipmentIdControl | validateField }}</mat-error
          >
        </div>
      </div>
      <div class="flex align-center gap-3">
        <div class="shipping-quote__label">Carrier</div>
        <div class="shipping-quote__input">
          <mat-select
            formControlName="carrierCode"
            class="lum-select"
            (selectionChange)="onSelectCarrier($event)"
            *ngIf="!(loadingCarriers$ | async); else inputLoader"
          >
            <mat-option
              *ngFor="let carrier of carriers; trackBy: trackByCode"
              [value]="carrier?.code"
              >{{ carrier.name }}</mat-option
            >
          </mat-select>
          <mat-error *ngIf="carrierCodeControl && carrierCodeControl.invalid">{{
            carrierCodeControl | validateField
          }}</mat-error>
        </div>
      </div>
      <div class="flex align-center gap-3" formGroupName="weight">
        <div class="shipping-quote__label">Weight</div>
        <div class="shipping-quote__input flex">
          <div class="flex align-center gap-1" formGroupName="pounds">
            <div class="flex flex-column">
              <input
                formControlName="value"
                type="number"
                min="0"
                matInput
                class="lum-input"
              />
            </div>
            <div class="flex justify-content-end">
              <span
                class="
                  text-underline cursor-pointer block w-25 text-purple-600 font-semi-bold
                "
              >
                (LBS)
              </span>
            </div>
          </div>
          <div class="flex align-center gap-1" formGroupName="ounces">
            <div class="flex flex-column">
              <input
                formControlName="value"
                type="number"
                min="0"
                matInput
                class="lum-input"
              />
            </div>
            <div class="flex justify-content-end">
              <span
                class="
                  text-underline cursor-pointer block w-25 text-purple-600 font-semi-bold
                "
              >
                (OZ)
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex align-center gap-3">
        <div class="shipping-quote__label">Package</div>
        <div class="shipping-quote__input">
          <mat-select
            formControlName="packageCode"
            class="lum-select"
            *ngIf="!(loadingPackages$ | async); else inputLoader"
          >
            <mat-option
              *ngFor="let package of packages; trackBy: trackById"
              [value]="package?.code"
              >{{ package.name }}</mat-option
            >
          </mat-select>
        </div>
      </div>

      <div class="flex align-center gap-3">
        <div class="shipping-quote__label">Service</div>
        <div class="shipping-quote__input">
          <mat-select
            formControlName="serviceCode"
            class="lum-select"
            *ngIf="!(loadingServices$ | async); else inputLoader"
          >
            <mat-option value=""></mat-option>
            <mat-option
              *ngFor="let service of services; trackBy: trackById"
              [value]="service?.code"
              >{{ service.name }}</mat-option
            >
          </mat-select>
        </div>
      </div>

      <div class="flex align-center gap-3" formGroupName="dimensions">
        <div class="shipping-quote__label">Size</div>
        <div class="shipping-quote__input flex justify-space-between gap-7">
          <div class="flex align-center gap-1">
            <input
              formControlName="length"
              type="number"
              min="0"
              matInput
              class="lum-input"
            />
            L
          </div>
          <div class="flex align-center gap-1">
            <input
              formControlName="width"
              type="number"
              min="0"
              matInput
              class="lum-input"
            />
            W
          </div>
          <div class="flex align-center gap-1">
            <input
              formControlName="height"
              type="number"
              min="0"
              matInput
              class="lum-input"
            />
            H
            <span
              class="text-underline cursor-pointer text-purple-600 font-semi-bold"
              #menuTrigger="matMenuTrigger"
              [matMenuTriggerFor]="dimensionMenu"
            >
              ({{ dimensionUnit }})
            </span>
            <mat-menu class="lum-mat-menu" #dimensionMenu="matMenu">
              <button
                *ngFor="let unit of dimensionUnits; trackBy: trackByLabel"
                mat-menu-item
                (click)="onSetUnit('dimensions.units', unit.value)"
              >
                {{ unit.value }} ({{ unit.label }})
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
      <div
        class="flex align-center gap-3"
        *ngIf="!data.isBulkUpdate && this.form.value.carrierCode"
      >
        <div class="shipping-quote__label">Confirmation</div>
        <div class="shipping-quote__input flex align-center gap-2">
          <mat-select formControlName="confirmation" class="lum-select">
            <mat-option
              *ngFor="
                let option of shippingLabelFacade.getConfirmationOptions(
                  this.form.value.carrierCode
                );
                trackBy: trackByValue
              "
              [value]="option"
              >{{ option }}</mat-option
            >
          </mat-select>
        </div>
      </div>
      <div
        class="lum-modal__footer flex align-center"
        *ngIf="data?.orderStatus !== eSalesOrderStatus.SHIPPED"
      >
        <div
          *ngIf="!data.isBulkUpdate"
          class="rates-container flex align-items-center gap-2"
        >
          <div class="rates-content flex flex-column">
            <span class="text-medium font-semi-bold text-green-900">Rate</span>
            <span>{{
              shippingRate
                ? shippingRate.shipmentCost + shippingRate.otherCost
                : (0 | currency)
            }}</span>
          </div>
          <span class="flip-x">
            <i
              class="fa fa-undo text-large cursor-pointer"
              [ngClass]="{
                'reverse-spin text-gray-400': shippingRatesLoading$ | async,
              }"
              (click)="onRefreshRate()"
            ></i>
          </span>
        </div>
        <div class="flex ml-auto lum-modal__action gap-2">
          <button
            class="lum-button lum-button--large"
            [disabled]="form.invalid || (submittingForm$ | async)"
          >
            <span class="d-flex align-items-center">
              <i class="fas fa-file-export mr-2"></i>
              <span>{{
                data.isBulkUpdate ? 'Update' : 'Print Shipping Label'
              }}</span>
              <mat-spinner
                class="inline-block ml-1"
                [diameter]="16"
                *ngIf="(submittingForm$ | async) || false"
              ></mat-spinner>
            </span>
          </button>
        </div>
      </div>
    </form>
  </ng-template>
</div>

<ng-template #inputLoader>
  <div class="lum-input">
    <mat-spinner class="ml-auto" [diameter]="16"></mat-spinner>
  </div>
</ng-template>
